class VideoPlayPause extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    this.video = this.parentNode.querySelector('video');
    this.querySelector('button').addEventListener('click', this.togglePlayPause.bind(this));
  }

  handleOthers(state) {
    let videos = this.dataset.sectionVideo
      ? this.closest('[id^="shopify-section-template-"]').querySelectorAll('video')
      : document.querySelectorAll('.media-preview.hover-video');
    videos.forEach((video) => {
      let parent = this.dataset.sectionVideo ? video.parentNode : video.parentNode.parentNode;
      if (parent.querySelector('video-play-pause')) {
        this.handleVideoState(video, state);
      }
    });
  }

  handleVideoState(video, state) {
    state ? video.play() : video.pause();
    const label = state ? 'Pause video' : 'Play video';
    let parent = this.dataset.sectionVideo ? video.parentNode : video.parentNode.parentNode;
    parent.querySelector('video-play-pause').classList.toggle('paused', !state);
    parent.querySelector('video-play-pause button').setAttribute('aria-label', label);
    parent.querySelector('video-play-pause button').setAttribute('title', label);
    parent.querySelector('video-play-pause button').setAttribute('aria-pressed', String(!state));
  }

  togglePlayPause() {
    this.handleOthers(this.video.paused);
  }
}

customElements.define('video-play-pause', VideoPlayPause);

document.querySelectorAll('video').forEach((video, idx) => {
  if (video.closest('.product .product__media-wrapper')) return;
  let videoId = video.id;
  if (!video.id) {
    videoId = `video-control-id-${idx + 1}`;
    video.id = videoId;
  }
  const videoPlayPause = document.createElement('video-play-pause');
  const label = video.autoplay ? 'Pause video' : 'Play video';
  const button = document.createElement('button');
  button.setAttribute('aria-controls', videoId);
  button.setAttribute('type', 'button');
  button.setAttribute('aria-label', label);
  button.setAttribute('title', label);
  button.setAttribute('aria-pressed', "false");
  videoPlayPause.appendChild(button);
  const cardMedia = video.closest('.card__media');
  !cardMedia && videoPlayPause.setAttribute('data-section-video', 'true');
  let appendTo = cardMedia ? video.parentNode.parentNode : video.parentNode;
  appendTo.appendChild(videoPlayPause);
});
